import { PaymentV2Enum } from "redmond";
import { Payment, PaymentOpaqueValue } from "@b2bportal/purchase-api";
import { IRewardsAllocation } from "./rewardsAllocation";

export const buildMultiRewardsPaymentEntries = (
  allocations: IRewardsAllocation[]
): PaymentOpaqueValue[] =>
  allocations
    .filter((allocation) => allocation.fiat.value > 0)
    .map(
      (allocation) =>
        ({
          type: Payment.Rewards,
          value: {
            paymentAmount: {
              rewardsAccountId: allocation.accountReferenceId,
              fiatValue: {
                amount: allocation.fiat.value,
                currency: allocation.fiat.currencyCode,
              },
              rewardsPrice: {
                value: allocation.rewards.value,
                currency: allocation.rewards.currency,
              },
            },
            PaymentV2: PaymentV2Enum.Rewards,
          },
        } satisfies PaymentOpaqueValue)
    );
